import ParserBase from "./parser-base";
import ValueMapper from "../common/value-mapper";

/**
 * 作業記録の受信情報を表示情報に変換する
 */
class Worklog extends ParserBase {
  /**
   * 受信した作業情報を表示データに変換する
   * @param {受信した作業情報} data
   * @returns 表示データ
   */
  contentsParse(data) {
    void data;
    return [
      ValueMapper.join(
        [
          { value: "通し替え", condition: data.seedling_replacement },
          { value: "採苗器作成", condition: data.seedling_collector_create },
          { value: "採苗", condition: data.seedling_perform },
          { value: data.seedling_quantity !== -1 ? "採苗枚数：" + data.seedling_quantity + "枚" : null, condition: data.seedling_quantity !== -1 },
          { value: "種場移動", condition: data.seedling_seed_field_move },
          ...data.seedling_others,
        ],
        "<br />"
      ).present((message) => {
        return {
          title: "採苗の管理",
          message: message,
        };
      }),
      ValueMapper.join(
        [
          { value: "筏移動", condition: data.raft_move },
          { value: "空筏移動", condition: data.raft_move_of_empty },
          { value: "吊り手上げ", condition: data.raft_strap_lift },
          { value: "筏修理", condition: data.raft_strap_repair },
          { value: "筏解体", condition: data.raft_dismantling },
          ...data.raft_others,
        ],
        "<br />"
      ).present((message) => {
        return {
          title: "筏の管理",
          message: message,
        };
      }),
      ValueMapper.join(
        [
          { value: "船底掃除", condition: data.ship_seabed_cleaning },
          { value: "船修繕", condition: data.ship_repair },
          { value: "エンジン修繕", condition: data.ship_engine_repair },
          ...data.ship_others,
        ],
        "<br />"
      ).present((message) => {
        return {
          title: "船の管理",
          message: message,
        };
      }),
      ValueMapper.join(
        [
          { value: "機械の整備", condition: data.workplace_facility_repair },
          { value: "修理", condition: data.workplace_repair },
          ...data.workplace_others,
        ],
        "<br />"
      ).present((message) => {
        return {
          title: "作業場の管理",
          message: message,
        };
      }),
      ValueMapper.join(
        [
          { value: "資材購入", condition: data.material_purchase },
          { value: "資材運搬", condition: data.material_transportation },
          ...data.material_others,
        ],
        "<br />"
      ).present((message) => {
        return {
          title: "資材の管理",
          message: message,
        };
      }),
      ValueMapper.join(data.other_works, "<br />").present((message) => {
        return {
          title: "その他作業",
          message: message,
        };
      }),
      ValueMapper.string(data.today_work_details).present((message) => {
        return {
          title: "本日の作業詳細",
          message: message,
        };
      }),
      // 表示内容のないの項目を除外する
    ].filter((item) => item != undefined);
  }
}

export default new Worklog({
  type: "object",
  properties: {
    type: { type: "string", enum: ["WORKLOG"] },
    worklog_date: { type: "string", format: "date" },
    raft_move: { type: "boolean" },
    ship_repair: { type: "boolean" },
    raft_strap_lift: { type: "boolean" },
    raft_dismantling: { type: "boolean" },
    seedling_perform: { type: "boolean" },
    workplace_repair: { type: "boolean" },
    material_purchase: { type: "boolean" },
    raft_strap_repair: { type: "boolean" },
    raft_move_of_empty: { type: "boolean" },
    ship_engine_repair: { type: "boolean" },
    seedling_replacement: { type: "boolean" },
    ship_seabed_cleaning: { type: "boolean" },
    material_transportation: { type: "boolean" },
    seedling_seed_field_move: { type: "boolean" },
    seedling_quantity: { type: "number" },
    seedling_collector_create: { type: "boolean" },
    workplace_facility_repair: { type: "boolean" },
    today_work_details: { type: "string" },
    other_works: {
      type: "array",
      items: {
        type: "string",
      },
    },
    raft_others: {
      type: "array",
      items: {
        type: "string",
      },
    },
    ship_others: {
      type: "array",
      items: {
        type: "string",
      },
    },
    material_others: {
      type: "array",
      items: {
        type: "string",
      },
    },
    seedling_others: {
      type: "array",
      items: {
        type: "string",
      },
    },
    workplace_others: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: [
    "type",
    "worklog_date",
    "raft_move",
    "ship_repair",
    "raft_strap_lift",
    "raft_dismantling",
    "seedling_perform",
    "workplace_repair",
    "material_purchase",
    "raft_strap_repair",
    "raft_move_of_empty",
    "ship_engine_repair",
    "today_work_details",
    "seedling_replacement",
    "ship_seabed_cleaning",
    "material_transportation",
    "seedling_seed_field_move",
    "seedling_quantity",
    "seedling_collector_create",
    "workplace_facility_repair",
    "other_works",
    "raft_others",
    "ship_others",
    "material_others",
    "seedling_others",
    "workplace_others",
  ],
});
